export default __webpack_public_path__ + "static/media/SriKanakaMahalakshmi.00641c25.webp";